export interface User {
  id: string;
  user_name: string;
  mobile_number: string;
  email_id: string;
  user_city?: string;
  user_state?: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

export const getCurrentUser = (): User | null => {
  try {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  } catch (error) {
    console.error('Error parsing current user:', error);
    return null;
  }
};

export const setCurrentUser = (user: User): void => {
  try {
    localStorage.setItem('currentUser', JSON.stringify(user));
  } catch (error) {
    console.error('Error setting current user:', error);
  }
};

export const clearCurrentUser = (): void => {
  try {
    localStorage.removeItem('currentUser');
  } catch (error) {
    console.error('Error clearing current user:', error);
  }
};

export const isAuthenticated = (): boolean => {
  return getCurrentUser() !== null;
}; 